import React from "react";
import { Query } from "../../../@Utils/AdmediaryApi";
import { Loader, Schema, Form } from "rsuite";
import SelectPicker from "rsuite/lib/SelectPicker";
import Field from "../../Field";

const { StringType, NumberType } = Schema.Types;

const model = Schema.Model({
  source_id: NumberType(),
  affiliate_id: NumberType().isRequired("Affiliate ID is required."),
  contract_id: NumberType().isRequired("Contract ID is required."),
  sid1: StringType(),
  sid2: StringType(),
  sid3: StringType(),
  sid4: StringType(),
  allow: NumberType().isRequired("Select Allow please."),
});

type ProductCategorySourceFormType = {
  sourceId?: number;
  formRef?: React.MutableRefObject<any>;
  parentCallback?: any;
};

const ProductSourceForm: React.FC<ProductCategorySourceFormType> = ({
  sourceId = 0,
  formRef = null,
  parentCallback = () => {},
}) => {
  formRef = formRef || React.createRef();
  const [isLoading, setIsLoading] = React.useState(false);
  const emptySource = {
    source_id: 0,
    product_id: 0,
    contract_id: 0,
    active: [],
    enable_filters: [],
  };
  const [formValue, setFormValue] = React.useState(emptySource);
  const [formError, setFormError] = React.useState({});

  const params = {
    source_id: sourceId,
  };

  const fetchData = React.useCallback(async () => {
    const setData = (data: any) =>
      handleChange(prepareFormData(Array.isArray(data) ? data[0] : data));

    if (params.source_id === 0) {
      setData(emptySource);
      return;
    }

    try {
      setIsLoading(true);
      const results: any = await Query("buyer_contract_source", params);
      setData(results.data);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    } finally {
    }
  }, []);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  const prepareFormData = (record: any) => {
    if (record === null) {
      return;
    }

    return record;
  };

  const handleChange = (data: any) => {
    setFormValue(data);
    if (parentCallback instanceof Function) {
      parentCallback(data);
    }
  };

  if (isLoading || formValue === null) {
    return <Loader center size="lg" content="Loading..." />;
  }

  return (
    <Form
      ref={formRef}
      onChange={handleChange}
      onCheck={setFormError}
      model={model}
      layout="horizontal"
      formValue={formValue}
      formError={formError}
    >
      <Field label="Afid" name="affiliate_id" />
      <Field label="Sid1" name="sid1" />
      <Field label="Sid2" name="sid2" />
      <Field label="Sid3" name="sid3" />
      <Field label="Sid4" name="sid4" />
      <Field
        label="Allow"
        name="allow"
        placeholder="Select Allow"
        accepter={SelectPicker}
        searchable={false}
        cleanable={false}
        data={[
          { value: 1, label: "Allow" },
          { value: 0, label: "Block" },
        ]}
      />
    </Form>
  );
};

export default ProductSourceForm;
